import api from "./ApiService";
import fileDownload from "js-file-download";

class TransactionService {
  //Get transaction details
  getTransactionDetails(hotelId, lazyParams, filters) {
    return api.get(hotelId + "/transactions_details", {
      params: {
        month: filters.month,
        year: filters.year,
        page: lazyParams.page,
        itemsPerPage: lazyParams.rows,
        isSortingAsc: lazyParams.sortOrder,
        sortingProperty: lazyParams.sortField,
        accountCode: filters.accountCode,
        departmentCode: filters.departmentCode,
        description: filters.description,
        searchMode: filters.searchMode,
        amount: filters.amount,
      },
    });
  }

  uploadTransactionFile(hotelId, formData) {
    return api.post(hotelId + "/transactions/import", formData);
  }

  uploadFecTransactionFile(hotelId, formData) {
    return api.post(hotelId + "/transactions/import_fec", formData);
  }

  uploadVinciTransactionFile(hotelId, formData) {
    return api.post(hotelId + "/transactions/import_vinci", formData);
  }

  uploadTransactionFileProgress(hotelId, groupHotelId) {
    return api.get(hotelId + "/transactions/progress", {
      params: {
        groupHotelId: groupHotelId,
      },
    });
  }

  lovGetTransactionByHotelId(hotelId, filters) {
    return api.get(hotelId + "/transactions/lov", {
      params: {
        description: filters.selectedDescription,
        amount: filters.selectedAmount,
      },
    });
  }

  //Lov get transaction details
  lovGetTransactionDetails(hotelId, filters) {
    return api.get(hotelId + "/transactions_details/lov", {
      params: {
        description: filters.selectedDescription,
        amount: filters.selectedAmount,
      },
    });
  }
  //Export  transaction details
  exportTransactionDetailsFile(hotelId, filters) {
    return api
      .get(
        hotelId + "/transactions_details/export",
        {
          params: {
            year: filters.year,
            month: filters.month,
            accountCode: filters.accountCode,
            departmentCode: filters.departmentCode,
            description: filters.description,
            amount: filters.amount,
          },
        },

        { responseType: "blob" },
      )
      .then(res => {
        fileDownload(res.data, "Transaction.csv");
      });
  }

  getLastImportDate(hotelId) {
    return api.get(hotelId + "/transactions/last-import-date");
  }
}

export default new TransactionService();
